module.exports = __webpack_public_path__ + "f6803d3aebf4f09d520eef49aa1f23e0.png";